import { useQuery } from 'react-query';
import { CashRegistersService } from '../../services';
import { ICashRegister } from '../../interfaces';

export const useCashRegisters = () => {
  return useQuery<ICashRegister[], Error>(
    ['cash-registers', 'all'],
    async () => {
      const result = await CashRegistersService.getList({ per_page: 1000 });
      if (result.status === 200) return result.data.data;
      throw new Error(result.data as string);
    },
    { staleTime: 5 * 60 * 1000 },
  );
};
